// IframeMap.js
import React from 'react';

const IframeMap = ({ latitude, longitude }) => {
    const url = `/map/map-template.html?latitude=${latitude}&longitude=${longitude}`;

    return (
        <div className="ts-page-wrapper ts-homepage ts-full-screen-page" id="page-top">
            <iframe
                src={url}
                title="Map Template"
                style={{ width: '100%', height: '100vh', border: 'none' }}
            ></iframe>
        </div>
    );
};

export default IframeMap;
